var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9777 11.289C32.6469 11.921 32.677 12.9758 32.045 13.645L19.0559 27.3982C17.7662 28.7637 15.6036 28.7946 14.2755 27.4665L7.98816 21.1792C7.33728 20.5283 7.33728 19.473 7.98816 18.8221C8.63903 18.1713 9.6943 18.1713 10.3452 18.8221L16.6325 25.1095L29.6216 11.3563C30.2537 10.6871 31.3085 10.6569 31.9777 11.289Z",
    fill: "#71B48D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.9fbb82488f449a9a45224a9ca144e106.svg";
export { ForwardRef as ReactComponent };